<template>
  <div
    class="flex shadow-inner rounded-full p-0 bg-gray-50 overflow-hidden"
    :class="{ 'w-full h-full': !hasExplicitWidth }"
    :style="hasExplicitWidth ? { width: width + 'px', height: width + 'px' } : {}"
  >
  <template v-if="!(src||srcFull)">
    <div class="m-auto text-gray-300 font-medium">нет фото</div>
    
  </template>
    <img
    v-else
      :src="
      srcFull ? toSameOriginFilesUrl(srcFull) :
        buildFilesUrl('avatar/default/' + encodeURIComponent(src) + '.webp')
      "
      :alt="alt"
      class="object-cover w-full h-full"
    />
  </div>
</template>

<script setup>
import { buildFilesUrl, toSameOriginFilesUrl } from '~/utils/mediaUrl';

const props = defineProps({
  src: {
    type: String,
    default: "",
  },
  srcFull: {
    type: String,
    default: "",
  },
  alt: {
    type: String,
    default: "",
  },
  width: {
    type: Number,
    default: undefined,
  },
});

const hasExplicitWidth = computed(() => props.width !== undefined);
</script>
